<template>

    <div class="flex items-center justify-between">
        <div class="text-2xl font-bold">Dashboard</div>
    </div>
    <table class="min-w-full bg-white">
        <thead>
            <tr>
                <th class="py-2 px-4 border-b-2 border-gray-300 text-left leading-tight">ID</th>
                <th class="py-2 px-4 border-b-2 border-gray-300 text-left leading-tight">Name</th>
                <th class="py-2 px-4 border-b-2 border-gray-300 text-left leading-tight">Color</th>
                <th class="py-2 px-4 border-b-2 border-gray-300 text-left leading-tight">Logo</th>
                <th class="py-2 px-4 border-b-2 border-gray-300 text-left leading-tight">Background</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="client in clients" :key="client.id" class="hover:bg-gray-100 cursor-pointer" @click="openClient(client.slug)">
                <td class="py-2 px-4 border-b border-gray-300">{{ client.id }}</td>
                <td class="py-2 px-4 border-b border-gray-300">{{ client.name }}</td>
                <td class="py-2 px-4 border-b border-gray-300">
                    <span :style="{ backgroundColor: client.color }" class="inline-block w-4 h-4 rounded-full"></span>
                </td>
                <td class="py-2 px-4 border-b border-gray-300">
                    <img :src="client.logo_url" alt="Logo" class="w-8 h-8 object-cover">
                </td>
                <td class="py-2 px-4 border-b border-gray-300">
                    <img :src="client.bg_url" alt="Background" class="w-16 h-9 object-cover">
                </td>
            </tr>
        </tbody>
    </table>

</template>

<script setup>
import { computed } from 'vue'
import { usePage, router } from '@inertiajs/vue3'


const page = usePage()

const clients = computed(() => {
    return page.props.clients || [];
})

const openClient = (slug) => {
    window.location.href = `/clients/pay/${slug}`
}

</script>

